export default __webpack_public_path__ + "static/media/download.44eb2a3c.svg";